export default __webpack_public_path__ + "static/media/arrowForward.963fdd1d.svg";